import React from 'react';
import { useLocation, useRouteMatch, Route, Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getClass } from '../../../utils/component-helpers';
import './tabbed-cards.scss';

//	This component is a dressed up React Router and should be used in a similar fashion
const TabbedCards = props => {
  const { children, onSetTab, styleType, fallbackPath, fittedUnderline } = props;
  const tabs = React.Children.toArray(children);
  const { pathname } = useLocation();
  const { path, url } = useRouteMatch();
  const onlyOneTab = tabs.filter(tab => tab.props.isShowing).length === 1;

  return (
    <div className="tabbed-cards">
      <div className={getClass('tabs', styleType)}>
        {tabs.map(tab => {
          const selected = !!pathname.match(`/${tab.props.path}`);

          if (!tab.props.isShowing || onlyOneTab) {
            return null;
          }

          return React.cloneElement(tab, {
            key: tab.props.name,
            url,
            onSetTab,
            selected,
            styleType,
            fittedUnderline,
          });
        })}
      </div>
      <div className={getClass('card', styleType)}>
        <Switch>
          {fallbackPath && (
            <Route exact path={`${path}/`}>
              <Redirect to={`${url}/${fallbackPath}`} />
            </Route>
          )}
          {tabs.map(tab => {
            if (!tab.props.isShowing) return null;
            return (
              <Route
                key={tab.props.name}
                path={`${path}/${tab.props.path}`}
                exact={tab.props.exact}
                render={tab.props.render}
              >
                {tab.props.children}
              </Route>
            );
          })}
        </Switch>
      </div>
    </div>
  );
};

TabbedCards.propTypes = {
  // children: PropTypes.oneOfType([
  // 	PropTypes.arrayOf(Tab),
  // 	Tab
  // ]).isRequired,
  onSetTab: PropTypes.func,
  styleType: PropTypes.oneOf(['block', 'round']),
  fittedUnderline: PropTypes.bool,
};

TabbedCards.defaultProps = {
  onSetTab: null,
  styleType: 'round',
  fittedUnderline: false,
};

export default TabbedCards;
